module.exports = __webpack_public_path__ + "images/feature/0707_doc_code_1-697fcaaf77ca1f548be8f7e75802b01f.jpg";